import RewardsSearchInput from './RewardsSearchInput';

export default RewardsSearchInput;
